import { render, staticRenderFns } from "./TopTenBanksByAmountFiled.vue?vue&type=template&id=b2673038&"
import script from "./TopTenBanksByAmountFiled.vue?vue&type=script&lang=js&"
export * from "./TopTenBanksByAmountFiled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports